<template>
  <div class="contact column__center__center g-16">
    <h4>{{ $t('home.reachout') }}</h4>
    <div class="row__center__center g-16">
      <a
        href="mailto:adrianoj@icloud.com"
        class="row__center__center"
      >
        <img
          src="/email.svg"
          alt="Email"
        />
      </a>
      <a
        href="https://www.linkedin.com/in/adriano-vieira-neto/"
        target="_blank"
        class="row__center__center"
      >
        <img
          src="/linkedin.svg"
          alt="Linkedin"
        />
      </a>
      <a
        href="https://github.com/adriano-vieira-dev"
        target="_blank"
        class="row__center__center"
      >
        <img
          src="/github.svg"
          alt="Github"
        />
      </a>
      <a
        href="https://x.com/adrianov_dev"
        target="_blank"
        class="row__center__center"
      >
        <img
          src="/x.svg"
          alt="X"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style lang="scss" scoped>
.contact {
  height: 400px;

  a {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: white;

    &:hover img {
      filter: invert(1) sepia(1) saturate(20) hue-rotate(70deg) brightness(0.6);
    }

    img {
      width: 24px;
      aspect-ratio: 1;
    }
  }
}
</style>
